import React, { useState } from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { User, Mail } from 'lucide-react';

const Settings = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    email: user?.email || '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Password change logic would go here
    console.log('Settings update:', formData);
  };

  return (
    <Layout>
      <div className="p-6 md:p-8 lg:p-12">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold tracking-tight text-[#F3F4F6] mb-2">
            Settings
          </h1>
          <p className="text-lg text-[#9CA3AF]">
            Manage your account settings
          </p>
        </div>

        <div className="max-w-2xl">
          {/* Account Information */}
          <div className="rounded-lg border border-[#2A2D36] bg-[#13151A]/80 backdrop-blur-sm p-6 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.5)] mb-6">
            <div className="flex items-center gap-3 mb-6">
              <User size={24} className="text-[#183871]" strokeWidth={1.5} />
              <h2 className="text-2xl font-semibold tracking-tight text-[#F3F4F6]">
                Account Information
              </h2>
            </div>

            <div className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-[#F3F4F6]">
                  Email Address
                </Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#9CA3AF]" size={20} />
                  <Input
                    id="email"
                    type="email"
                    value={formData.email}
                    disabled
                    className="pl-10 bg-[#1F2128] border-[#2A2D36] text-[#9CA3AF]"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Change Password */}
          <div className="rounded-lg border border-[#2A2D36] bg-[#13151A]/80 backdrop-blur-sm p-6 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.5)]">
            <h2 className="text-2xl font-semibold tracking-tight text-[#F3F4F6] mb-6">
              Change Password
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="currentPassword" className="text-[#F3F4F6]">
                  Current Password
                </Label>
                <Input
                  id="currentPassword"
                  type="password"
                  placeholder="••••••••"
                  value={formData.currentPassword}
                  onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })}
                  className="bg-[#1F2128] border-[#2A2D36] text-[#F3F4F6] placeholder:text-[#9CA3AF]"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="newPassword" className="text-[#F3F4F6]">
                  New Password
                </Label>
                <Input
                  id="newPassword"
                  type="password"
                  placeholder="••••••••"
                  value={formData.newPassword}
                  onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
                  className="bg-[#1F2128] border-[#2A2D36] text-[#F3F4F6] placeholder:text-[#9CA3AF]"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="confirmPassword" className="text-[#F3F4F6]">
                  Confirm New Password
                </Label>
                <Input
                  id="confirmPassword"
                  type="password"
                  placeholder="••••••••"
                  value={formData.confirmPassword}
                  onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                  className="bg-[#1F2128] border-[#2A2D36] text-[#F3F4F6] placeholder:text-[#9CA3AF]"
                />
              </div>

              <Button
                type="submit"
                className="bg-[#183871] hover:bg-[#1F4BA1] text-white shadow-[0_0_15px_rgba(24,56,113,0.3)]"
              >
                Update Password
              </Button>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Settings;
